import styled from "styled-components";

import { FakeRow } from "../DocumentManagement/DocumentManagementSharedStyles";
import { InvoiceContainer } from "../Invoice/InvoiceStyles";
import { InvoicesContainer, TableHeader } from "../Invoices/InvoicesStyles";
import { SearchBar } from "../Payment/FilterStyles";
import { Container, MainButton } from "./AdditionalVolanteModalStyles";

export const RucsContainer = styled(Container)`
  padding: 2rem 4rem;
  overflow-y: auto;
  overflow-x: hidden;
  .warning-message {
    ${(props) => `
      background-color: ${
        props.theme.colors.supportYellow + props.theme.transparencies.p20
      };
      color: ${props.theme.colors.blackTextBody};
    `}

    border-radius: 10px;
    display: flex;
    margin-top: 1.5rem;
    padding: 0 1rem;

    & > p {
      font-size: 1.4rem;
    }
  }

  .alert-spacing {
    margin: 2rem;
  }

  .right-align {
    align-self: flex-end;
  }

  .spacing {
    padding: 1.5rem 0;
  }

  .rows {
    background: ${({ theme }) => theme.colors.backgroundGray};
  }

  width: 90rem;
  @media (max-width: 1450px) {
    max-height: 55rem;
    overflow-y: auto;
    overflow-x: hidden;
    width: 85rem;
  }
  @media (max-width: 750px) {
    width: 53rem;
  }
  @media (max-width: 335px) {
    width: 40rem;
  }
`;

export const RucsButton = styled(MainButton)`
  background-color: ${(props) => props.theme.colors.accentGreen};
  margin-bottom: 1rem;

  :disabled,
  [disabled] {
    background-color: ${(props) =>
      props.theme.colors.accentGreen + props.theme.transparencies.p20};
    cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  }
`;

export const RucsRow = styled(InvoiceContainer)`
  justify-items: flex-start;
  padding: 0.5rem 0;

  .ruc-id {
    color: ${({ theme }) => theme.colors.primaryBlue};
    font-size: 1.2rem;
    font-weight: bold;
  }
`;

export const RucsTableHeader = styled(TableHeader)`
  padding: 0;
`;

export const RucsTableContainer = styled(InvoicesContainer)`
  padding: 1.5rem 0;

  .left-align {
    align-items: flex-start;
    margin-left: 2rem;
  }
`;

export const RucsSearchBar = styled(SearchBar)`
  width: 100%;

  h3 {
    ${(props) => `
      color: ${props.theme.colors.gray72};
    `}
    font-size: 1.2rem;
    font-weight: 700;
    margin-left: 0.2rem;
  }
`;

export const RucsFakeRow = styled(FakeRow)`
  height: 5.3rem;
`;

interface IDivSearcRuc {
  width?: string;
}
export const DivSearcRuc = styled.div<IDivSearcRuc>`
  width: ${(props) => (props.width ? props.width : "80rem")};
  padding-right: 2rem;
  @media (max-width: 750px) {
    width: 40rem;
  }
  @media (max-width: 335px) {
    width: 25rem;
  }
`;
interface IDivHeaderRuc {
  marginLeft?: string;
}
export const DivHeaderRuc = styled.div<IDivHeaderRuc>`
  ${(props) => `
  align-items: flex-start !important;
  display: flex !important;
  justify-content: flex-start !important;
  font-family: ${props.theme.fontFamilies.primaryFont};
  margin-left: ${props.marginLeft ? props.marginLeft : "0rem"} !important;
   @media (max-width: 750px) {
    align-items: center !important;
    justify-content: center !important;
  }
  `}
`;

export const DivBodyRuc = styled.div`
  ${(props) => `
  align-items: flex-start !important;
  display: flex !important;
  justify-content: flex-start !important;
  font-family: ${props.theme.fontFamilies.primaryFont};
   @media (max-width: 750px) {
    align-items: center !important;
    justify-content: center !important;
  }
  `}
`;
